export default {

  getEnum(type) {
    console.log('getEnum DZYSLX', DZYSLX)
    for (const key in DZYSLX) {
      if (DZYSLX[key].type === type) {
        return DZYSLX[key]
      }
    }
    return ''
  },


  onlyOk(zzjglx, ...types) {
    if (types && types.length > 0) {
      for (let i = 0; i < types.length; i++) {
        let type = types[i]
        if (zzjglx === type.type) return true
      }
      return false
    }
  },

  /**
   * Description: 省
   */
  isSheng(zzjglx) {
    return zzjglx === DZYSLX.SHENG.type
  }
  ,

  /**
   * Description: 市
   */
  isShi(zzjglx) {
    return zzjglx === DZYSLX.SHI.type
  }
  ,

  /**
   * Description: 区(县)
   */
  isQX(zzjglx) {
    return zzjglx === DZYSLX.QX.type
  }
  ,

  /**
   * Description: 乡/镇/街道
   */
  isXZJD(zzjglx) {
    return zzjglx === DZYSLX.XIANG.type ||
      zzjglx === DZYSLX.ZHEN.type ||
      zzjglx === DZYSLX.JD.type
  }
  ,

  /**
   * Description: 社区/村/居
   */
  isSQCJW(zzjglx) {
    return zzjglx === DZYSLX.SQ.type ||
      zzjglx === DZYSLX.JWH.type ||
      zzjglx === DZYSLX.CWH.type
  }
  ,

  getXzqhArr(zzjglx) {
    if (this.isQX(zzjglx)) return this.getQX()
    if (this.isXZJD(zzjglx)) return this.getXZJD()
    if (this.isSQCJW(zzjglx)) return this.getSQCJW()
    return []
  }
  ,
  getSheng() {
    let arr = []
    arr.push(DZYSLX.SHENG)
    return arr
  }
  ,
  getShi() {
    let arr = []
    arr.push(DZYSLX.SHI)
    return arr
  }
  ,
  getQX() {
    let arr = []
    arr.push(DZYSLX.QX)
    return arr
  }
  ,

  getXZJD() {
    let arr = []
    arr.push(DZYSLX.XIANG)
    arr.push(DZYSLX.ZHEN)
    arr.push(DZYSLX.JD)
    return arr
  }
  ,

  getSQCJW() {
    let arr = []
    arr.push(DZYSLX.SQ)
    arr.push(DZYSLX.JWH)
    arr.push(DZYSLX.CWH)
    return arr
  }
  ,

}
